// extracted by mini-css-extract-plugin
export default {"hide":"notification-hide-mzZf20","messages":"notification-messages-BM0AYD"};